import defaultTheme from 'styles/lib/theme.module.scss';
import 'styled-components';
import { DefaultTheme } from 'styled-components';

// some of these might be number!
declare module 'styled-components' {
  export interface DefaultTheme {
    colorBlack: string,
    colorBlackHover: string,
    colorBlackDark: string,
    colorGreyDark: string,
    colorGreyDarkHover: string,
    colorGrey: string,
    colorGreyLight: string,
    colorGreyExtraLight: string,
    colorWhite: string,
    colorGreen: string,
    colorGreenBackground: string,
    colorBlue: string,
    colorBlueDark: string,
    colorBlueBackground: string,
    colorYellow: string,
    colorMagenta: string,
    colorPink: string,
    colorLightBackground: string,
    colorSuccess: string,
    colorSuccessBackground: string,
    colorWarning: string,
    colorWarningBackground: string,
    colorError: string,
    colorErrorBackground: string,
    colorDanger: string,
    colorFacebook: string,
    colorTwitter: string,
    colorInstagram: string,
    colorYoutube: string,
    colorTextBlack: string,
    colorTextLight: string,
    colorTextLightHover: string,
    colorTextWhite: string,
    colorTextLinkPrimary: string,
    colorTextLinkPrimaryHover: string,
    colorTextLinkSecondary: string,
    colorButtonPrimary: string,
    colorButtonPrimaryHover: string,
    colorButtonPrimaryText: string,
    colorButtonSecondaryBorder: string,
    colorButtonSecondaryBorderHover: string,
    colorButtonSecondaryText: string,
    colorButtonTertiaryBorder: string,
    colorButtonTertiaryBorderHover: string,
    colorButtonTag: string,
    colorButtonTagHover: string,
    colorButtonFocus: string,
    colorBadgeMember: string,
    colorBadgePost: string,
    colorBadgeNew: string,
    colorWhite80: string,
    colorTransparent: string,
    colorShadow: string,
    colorLightYellow: string,
    colorDarkYellow: string,
    fontFamilyMain: string,
    fontWeightNormal: string,
    fontWeightBold: string,
    fontFamilyTitle: string,
    fontWeightNormalTitle: string,
    fontWeightBoldTitle: string,
    fontSizeXs: string,
    fontLineHeightXs: string,
    fontSizeS: string,
    fontLineHeightS: string,
    fontLineHeightSWide: string,
    fontSizeM: string,
    fontLineHeightM: string,
    fontSizeL: string,
    fontLineHeightL: string,
    fontSizeXl: string,
    fontLineHeightXl: string,
    navHeightTop: string,
    navHeightBottom: string,
    screenXxsMin: string,
    screenXsMin: string,
    screenSmMin: string,
    screenSmMinHeight: string,
    screenMdMin: string,
    screenLgMin: string,
    screenXlMin: string,
    siteWidth: string,
    screenXxsMax: string,
    screenXsMax: string,
    screenSmMax: string,
    screenMdMax: string,
    screenLgMax: string,
    underScreenXxsmall: string,
    underScreenXsmall: string,
    underScreenSmall: string,
    underScreenIpad: string,
    underScreenMedium: string,
    underScreenLarge: string,
    underScreenXlarge: string,
    overScreenXsmall: string,
    overScreenSmall: string,
    overScreenMedium: string,
    overScreenLarge: string,
    overScreenXlarge: string,
    cardBorderRadius: string,
    shadowDefault: string,
    shadowLight: string,
    shadowTop: string,
    greyLine: string,
    zindexLiftTop: number,
  }
}

// concatenated variables have quotes in them, eg `overScreenSmall = "'min-width: 768px'"`
// replace all quotes in defaultTheme
const themeWithNoQuotes = Object.entries(defaultTheme).reduce((acc, [key, value]) => {
  acc[key] = value.replace(/"/g, '');
  return acc;
}, {});


export const theme = themeWithNoQuotes as unknown as DefaultTheme;
